<template>
  <div class="repair-status-item-footer">
    <div class="repair-status-item-footer__section">
      <div class="repair-status-item-footer__block">
        <p class="repair-status-item-footer__title">{{ messages?.article }}:</p>
        <p class="repair-status-item-footer__text">
          {{ response?.article }}
        </p>
      </div>
      <div v-if="0" class="repair-status-item-footer__block">
        <p class="repair-status-item-footer__title">Вид сервісу:</p>
        <p class="repair-status-item-footer__text">Чистка та шліфовка</p>
      </div>
    </div>

    <div v-if="0" class="repair-status-item-footer__section">
      <div class="repair-status-item-footer__block">
        <p class="repair-status-item-footer__title">Отримали замовлення:</p>
        <p class="repair-status-item-footer__text">Київ, вул.Хрещатик 38, "ЦУМ"</p>
      </div>
      <div class="repair-status-item-footer__block">
        <p class="repair-status-item-footer__title">Ім’я замовника:</p>
        <p class="repair-status-item-footer__text">Ольга Прокопенко</p>
      </div>
      <div class="repair-status-item-footer__block">
        <p class="repair-status-item-footer__title">Контактні дані:</p>
        <p class="repair-status-item-footer__text">+38 060 800 90 77</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const { result } = defineProps(['result']);
const response = computed(() => result?.response);
const messages = computed(() => result?.messages);
</script>

<script>
export default {
  name: 'RepairStatusItemFooter',
};
</script>

<style lang="scss" scoped>
.repair-status-item-footer {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 16px;
  align-items: self-start;
  font-weight: 500;
  font-size: 14px;
  @include point-md {
    grid-template-columns: repeat(2, 1fr);
  }
  &__section {
    display: grid;
    grid-row-gap: 16px;
  }
  &__block {
    display: grid;
    grid-row-gap: 8px;
  }
  &__title {
    color: #5f5f67;
  }
  &__text {
  }
}
</style>
